<template>
  <div class="row transaction">
    <!-- Spinner and error handling here -->
    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>
    <!-- <h4>Transactions</h4> -->
    <div
      class="p-4 col-12"
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <!-- <button class="btn btn-info m-2" @click="refresh('refresh')">
        Refresh
      </button> -->
      <h1
        class="p-0, m-0"
        style="font-size: 25px; text-transform: uppercase; font-weight: 700"
      >
        Merchants
      </h1>
      <router-link
        class="btn btn-info m-2"
        :to="`/dashboard/create-ptsp-merchant`"
        style="width: min-content"
        :style="{ display: isInstitution ? 'none' : 'block' }"
      >
        <i class="fa fa-plus"></i>
        Add Merchant
      </router-link>
    </div>

    <div class="col-12 p-0 d-flex align-items-center">
      <div class="form-row align-items-center">
        <div class="col-auto mt-3">
          <select
            class="form-control"
            v-model="selectedValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a search parameter</option>
            <option value="merchantName">Merchant Name</option>
            <option value="companyName">Business Name</option>
            <option value="institution">Institution Name</option>
            <option value="email">Email</option>
            <option value="phoneNumber">Phone Number</option>
            <option value="disabled">Status</option>
          </select>
        </div>

        <div class="col-auto mt-4" v-if="selectedValue === 'disabled'">
          <select
            class="form-control mb-2"
            v-model="searchValues[selectedValue]"
            placeholder="Select a search parameter"
          >
            <option value="">Select a status</option>
            <option value="false">Enabled</option>
            <option value="true">Disabled</option>
          </select>
        </div>

        <div
          class="col-auto mt-4"
          v-if="selectedValue && selectedValue !== 'disabled'"
        >
          <div class="input-group mb-2">
            <input
              id="inlineFormInputGroup"
              class="form-control"
              v-model="searchValues[selectedValue]"
              :placeholder="`Enter ${selectedValue.replace(/Id/g, ' Id')}`"
              type="text"
            />
          </div>
        </div>

        <div class="col-auto mt-2">
          <button
            type="submit"
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('filter')"
          >
            Search
          </button>
        </div>
        <div class="col-auto mt-2">
          <button
            type="submit"
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('reload')"
          >
            Refresh
          </button>
        </div>
        <div class="col-auto mt-2">
          <button
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('download')"
          >
            Download
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 p-0">
      <div
        class="card-plain p-0"
        style="
          align-items: center;
          justify-content: center;
          display: flex;
          padding: 15px 0;
        "
      >
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Merchant Name</th>
                <th scope="col" class="text-center">Business Name</th>
                <th scope="col" class="text-center">Institution Name</th>
                <th scope="col" class="text-center">Email</th>

                <th scope="col" class="text-center">Phone Number</th>
                <th scope="col" class="text-center">Sales Officer</th>

                <th scope="col" class="text-center">Status</th>
                <th scope="col" class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(merchant, index) in merchants" :key="merchant._id">
                <th class="text-center">
                  {{ limit * (page - 1) + (index + 1) }}
                </th>
                <td class="text-center">{{ merchant.merchantName }}</td>
                <td class="text-center">{{ merchant.companyName }}</td>
                <td class="text-center">
                  {{ merchant.institutionName || "NULL" }}
                </td>
                <td class="text-center">{{ merchant.email }}</td>

                <td class="text-center">{{ merchant.phoneNumber }}</td>

                <td class="text-center">
                  {{
                    merchant.salesOfficerId && merchant.salesOfficerId.firstName
                  }}
                </td>

                <td class="text-center text-uppercase">
                  <span
                    class="status"
                    :class="
                      merchant.disabled ? 'status-disabled' : 'status-enabled'
                    "
                    >{{ merchant.disabled ? "Disabled" : "enabled" }}</span
                  >
                </td>
                <td class="text-center">
                  <drop-down
                    title="Options"
                    :is-open="merchant.isDropdownOpen"
                    @change="toggleDropdown(merchant._id)"
                  >
                    <div class="p-2">
                      <router-link
                        :to="`/dashboard/ptsp-merchant/${merchant._id}`"
                      >
                        View Merchant
                      </router-link>
                    </div>

                    <div
                      class="p-2"
                      :style="{ display: isInstitution ? 'none' : 'block' }"
                    >
                      <router-link
                        :to="`/dashboard/merchant/${merchant._id}/terminals`"
                      >
                        View Terminals
                      </router-link>
                    </div>
                  </drop-down>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="pagination">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn btn-primary"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button
          class="btn btn-primary"
          :disabled="!hasNextPage"
          @click="refresh('next')"
        >
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn btn-primary">Total Records: {{ totalDocs }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import DropDown from "../components/multiDropDown.vue";
export default {
  components: { DropDown },
  data() {
    return {
      error: false,
      merchants: [],
      errorMsg: "",
      loading: false,
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      currentPage: 1,
      totalDocs: 0,
      limit: 20,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,

      userType: localStorage.getItem("userType"),
      searchValues: {
        merchantName: "",
        companyName: "",
        institution: "",
        email: "",
        phoneNumber: "",
        disabled: null,
      },
      selectedValue: "",
    };
  },

  computed: {
    isInstitution() {
      return this.userType === "INSTITUTIONS";
      //   return this.userType === 'super-admin';
    },
  },
  methods: {
    toggleDropdown(id) {
      this.merchants = this.merchants.map((merchant) => {
        if (merchant._id === id) {
          merchant.isDropdownOpen = !merchant.isDropdownOpen;
        } else {
          merchant.isDropdownOpen = false;
        }
        return merchant;
      });
    },
    async refresh(mode) {
      try {
        this.errorMsg = "";
        this.error = false;
        this.loading = true;
        let payload = {
          page: this.page,
          ...this.searchValues,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            break;
          case "reload":
            this.page = 1;
            payload = { page: this.page };
            this.selectedValue = "";
            this.searchValues = "";
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/auth/get-institution-merchants`,
          payload,
        );
        const {
          docs,
          totalDocs,
          limit,
          page,
          hasNextPage,
          hasPrevPage,
          totalPages,
          prevPage,
          nextPage,
        } = res.data.merchants;
        this.merchants = docs;
        this.merchants = docs.map((merchant) => ({
          ...merchant,
          isDropdownOpen: false,
        }));
        this.page = page;
        this.limit = limit;
        this.totalDocs = totalDocs;
        this.hasPrevPage = hasPrevPage;
        this.hasNextPage = hasNextPage;
        this.totalPages = totalPages;
        this.prevPage = prevPage;
        this.nextPage = nextPage;
      } catch (err) {
        this.error = true;
        this.errorMsg = "Unable to Fetch Merchants";
      }
      this.loading = false;
    },

    clearSearchFields() {
      this.searchValues = {
        merchantName: "",
        companyName: "",
        institution: "",
        email: "",
        phoneNumber: "",
        disabled: null,
      };
    },
  },

  watch: {
    selectedValue() {
      this.clearSearchFields();
      this.refresh();
    },
  },

  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/auth/get-institution-merchants`,
        {
          page: this.page,
        },
      );
      const {
        docs,
        totalDocs,
        limit,
        page,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
      } = res.data.merchants;
      this.merchants = docs;

      this.merchants = docs.map((merchant) => ({
        ...merchant,
        isDropdownOpen: false,
      }));
      this.page = page;
      this.limit = limit;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Merchants";
    }
    this.loading = false;
  },
};
</script>

<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
#list {
  list-style-type: none;
}
tbody {
  background: #fff !important;
}
.status {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}
.status-enabled {
  background: #1eb75b;
  color: #fff;
}
.status-disabled {
  background: #e02b00;
  color: #fff;
}

.pagination {
  justify-content: space-between;
  width: 100%;
}
.card-body {
  padding: 15px 0px !important;
}
</style>
